import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import 'dotdotdot-js'
import { TH } from 'src/app/constants/constants';

@Component({
  selector: 'app-oneam-privacy-notice',
  templateUrl: './oneam-privacy-notice.component.html',
  styleUrls: ['./oneam-privacy-notice.component.scss']
})
export class OneamPrivacyNoticeComponent implements OnInit{
  language = JSON.parse(localStorage.getItem('language'))
  language_flag = localStorage.getItem('language_flag')

  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';

  ngOnInit() {
    if (this.language == null) {
      this.language = JSON.parse(JSON.stringify(TH));
    }
    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

}